export default __webpack_public_path__ + "static/media/login_background.e4d2cb0f.jpg";